import {
    afterNextRender,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    DestroyRef,
    ElementRef,
    HostBinding,
    inject,
    Input,
    makeStateKey,
    PLATFORM_ID,
    signal,
    TransferState,
    ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';

import { AsyncPipe, DOCUMENT, isPlatformBrowser, isPlatformServer, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { AppService } from './app.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveToolbarDirective } from './reactive-toolbar.directive';
import { environment } from '../environments/environment';

@Component({
    imports: [RouterModule, NgOptimizedImage, RouterOutlet, NgTemplateOutlet, AsyncPipe, ReactiveToolbarDirective, FooterComponent],
    selector: 'iea-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
})
export class AppComponent {
    private readonly doc = inject(DOCUMENT);
    readonly app = inject(AppService);
    private readonly router = inject(Router);
    @ViewChild('mobMenu') mobMenu: ElementRef<HTMLDivElement> | undefined;
    private readonly destroyRef = inject(DestroyRef);
    @HostBinding('class')
    @Input()
    hostClass = 'app-bg';

    mobMenuStateClass = signal('');

    private readonly platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);

    constructor() {
        afterNextRender(async () => {
            // import('@lottiefiles/dotlottie-wc').then(() => {});
            await loadScript(`https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalytics.id}`);
            window['dataLayer'] ??= [];
            function gtag(...args) {
                window['dataLayer'].push(args);
            }
            gtag('js', new Date());
            gtag('config', environment.googleAnalytics.id);
        });

        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                if (this.mobMenuStateClass() === 'opened') this.toggleMenu();
                this.doc.body.scrollTop = 0;
            });
    }

    toggleMenu() {
        const curr = this.mobMenuStateClass() === 'opened' ? '' : 'opened';
        this.mobMenuStateClass.set(curr);
        const isMenuOpened = this.mobMenuStateClass() === 'opened';
        if (isMenuOpened) {
            this.doc.body.style.overflow = 'hidden';
        } else {
            this.doc.body.style.overflow = '';
        }
    }
}

function loadScript(src: string) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}
